module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAA6ElEQVRYhe2X0QnCMBCGf8UBnCAKZgBXcAM7RnxzEt/sGLqBbqADRKidoBsoSqDS465JQxVpvqdy1ybfHblAMXhGUgOsUWsAOwBzkqxZ6bw8W6Mu7rkibwiMuZTb/NCy+SdLACdr1JRkBFgBV3kowRKSgG/lTYIkJIEYvCX6EoCvRJ8CXhJ9C7RKTEikIzovxTuF4xsdEGGtrVEPEozjfWM2V/h5B5KA9xQs9ncSk7htZkK25n864FtRKOkQpilIUzCoQ3glkRaBgkS6U3A/LJLAlkS6w67FCui8PALIIjvx+jZzayUoAJ4+RzqFP/BqMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_confirmation_press@2x.png
// module id = 743
// module chunks = 0